import { convertToCamelCase } from '@vista-digital/utilities';
import { FormElementStyle } from '../../form-element-style';
export const getFieldProps = (props) => {
    const { id, name, className, showLabel, b, displayText, validationConfig, setHelpText, helpText, hideOptionalSuffixLabel } = props;
    return {
        id,
        name: name ? convertToCamelCase(name) : undefined,
        label: displayText === null || displayText === void 0 ? void 0 : displayText.label,
        showLabel,
        helpText: setHelpText ? undefined : helpText,
        style: helpText ? FormElementStyle.Error : FormElementStyle.Normal,
        className: b.block(undefined, className),
        optional: (validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.required) === false && !hideOptionalSuffixLabel,
        setHelpText
    };
};
//# sourceMappingURL=get-field-props.js.map